document.addEventListener('DOMContentLoaded', function () {
  const inputField = document.querySelector('.input-field');
  const dropdownContainer = document.querySelector('.categories-dropdown');

  if (inputField && dropdownContainer) {
    inputField.addEventListener('click', function () {
      dropdownContainer.classList.toggle('show');
    });

    document.addEventListener('click', function (e) {
      if (!inputField.contains(e.target) && !dropdownContainer.contains(e.target)) {
        dropdownContainer.classList.remove('show');
      }
    });
  }
});

/* Move existing Ishi megamenu into Figma header nav slot */
document.addEventListener('DOMContentLoaded', function () {
  var mount = document.getElementById('kg-header-nav-mount');
  var menu = document.getElementById('_desktop_top_menu');
  if (!mount || !menu) return;

  mount.appendChild(menu);

  var navbar = document.querySelector('#shopify-section-Ishi_megamenu .main-navbar');
  if (navbar) {
    navbar.classList.add('kg-header-nav-relocated');
  }
});



// // cart count update js

// document.addEventListener("DOMContentLoaded", function () {
//   const cartCountEl = document.querySelector("[data-cart-count]");

//   function updateCartCount(count) {
//     if (!cartCountEl) return;
//     cartCountEl.textContent = count > 0 ? `(${count})` : "";
//   }

//   // Listen for Shopify's cart:updated events (cart-notification triggers this)
//   document.addEventListener("cart:updated", (event) => {
//     const cart = event.detail.cart;
//     updateCartCount(cart.item_count);
//   });

//   // Fallback: check cart state on page load
//   fetch("/cart.js")
//     .then((res) => res.json())
//     .then((cart) => updateCartCount(cart.item_count));
// });
// pin checker js
document.addEventListener('DOMContentLoaded', function () {
  if (window.__PINCODE_WIDGET_LOADED) {
    console.warn('pincode.js loaded more than once — remove duplicate include.');
    return;
  }
  window.__PINCODE_WIDGET_LOADED = true;

  const openTriggers = document.querySelectorAll('[aria-controls="pincode-modal"]');
  const headerCity  = document.getElementById('header-pincode-label'); // will show only city OR "Enter Pincode"
  const headerDeliv = document.getElementById('header-pincode-deliv'); // not used now (kept for safety)

  const modal       = document.getElementById('pincode-modal');
  const backdrop    = document.getElementById('pincode-backdrop');
  const closeBtn    = document.getElementById('pincode-close');
  const signinCta   = document.getElementById('signin-cta');

  const input       = document.getElementById('pincode-input');
  const applyBtn    = document.getElementById('apply-pincode');
  const useLocationBtn = document.getElementById('use-location');
  const result      = document.getElementById('pincode-result');

  const ORIGIN_PIN = '121001';   // << YOUR WAREHOUSE PINCODE >>

  function openModal() { 
      if (!modal) return;
      modal.setAttribute('aria-hidden', 'false');
      input && input.focus();
  }

  function closeModal() { 
      if (!modal) return;
      modal.setAttribute('aria-hidden', 'true');
    result && (result.textContent = ''); 
  }

  openTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', openModal);
  });
  closeBtn && closeBtn.addEventListener('click', closeModal);
  backdrop && backdrop.addEventListener('click', closeModal);

  const customer = window.__SHOP_CUSTOMER || { logged_in: false };

  /* Reduce “Bhuj Sector 107” → “Bhuj”.
   But if it’s exactly a 6-digit pincode (e.g. "380001"),
   return it as-is so we can at least show the pin. */
  function simplifyAreaForHeader(areaText) {
    if (!areaText) return '';

    let t = areaText.trim();

  // NEW: if string is exactly a 6-digit pincode, keep it
  if (/^\d{6}$/.test(t)) {
    return t;
  }

  // remove 6-digit codes inside area (like "... 380001")
    t = t.replace(/\b\d{6}\b/g, '').trim();

    // if comma separated → take first
    t = t.split(',')[0].trim();

    const keywords = ['sector', 'taluka', 'ward', 'village', 'block', 'phase'];
    const lower = t.toLowerCase();

    // If contains sublocality token or number → reduce to first word
    if (keywords.some(k => lower.includes(k)) || /\d+/.test(t)) {
      const token = t.split(' ').find(w => /^[A-Za-z]+$/.test(w));
      return token || t;
    }

    return t;
  }


  /* Extract best area name from Nominatim address */
  function extractAreaFromAddress(address) {
    const keys = [
      'suburb', 'neighbourhood', 'locality', 'hamlet',
      'village', 'quarter', 'ward', 'residential',
      'borough', 'city_district', 'town', 'city', 'county'
    ];
    for (let k of keys) {
      if (address[k]) return String(address[k]).trim();
    }
    return '';
  }

  /* Update header – ONLY CITY NAME (or PIN) NEXT TO ICON */
  function updateHeaderLabel(pin, area) {
  // if area is empty, fall back to pin
  let base = (area && area.trim()) ? area.trim() : (pin || '').trim();

  const clean = simplifyAreaForHeader(base);

    if (!clean) {
      if (headerCity)  headerCity.textContent = 'Enter Pincode';
      if (headerDeliv) headerDeliv.textContent = '';
    } else {
    if (headerCity)  headerCity.textContent = clean;  // city or pin
      if (headerDeliv) headerDeliv.textContent = '';    // no second line
    }
  }


  /* Logged in user auto-fill */
  if (customer.logged_in) {
    if (document.getElementById('signin-area')) {
      document.getElementById('signin-area').style.display = 'none';
    }
    if (customer.address && customer.address.zip) {
      input.value = customer.address.zip;
      const areaCandidate =
        customer.address.address1 ||
        customer.address.address2 ||
        customer.address.city     ||
        '';
      const simple = simplifyAreaForHeader(areaCandidate);
      updateHeaderLabel(customer.address.zip, simple);

      localStorage.setItem('selected_pincode', JSON.stringify({
        pin: customer.address.zip,
        area: simple
      }));
    }
  } else {
    signinCta && signinCta.addEventListener('click', function () {
      window.location.href = '/account/login';
    });
  }

  /* Use My Location (inside modal and also re-used on page load) */
  useLocationBtn && useLocationBtn.addEventListener('click', function () {
    if (result) result.textContent = 'Getting your location…';
    if (!navigator.geolocation) { 
      if (result) result.textContent = 'Geolocation not supported'; 
      return; 
    }

    navigator.geolocation.getCurrentPosition(async function (pos) {
      const lat = pos.coords.latitude;
      const lon = pos.coords.longitude;

      if (result) result.textContent = 'Finding nearest postal code…';

      try {
        const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lon}&addressdetails=1`;
        const res = await fetch(url, { headers: { 'Accept': 'application/json' }});
        const data = await res.json();

        const address = data.address || {};
        const postcode = address.postcode || (data.display_name.match(/\d{6}/) || [])[0];
        const rawArea = extractAreaFromAddress(address);

        if (!postcode) {
          if (result) result.textContent = 'Could not determine postal code.';
          return;
        }

        if (input) input.value = postcode;

        const simple = simplifyAreaForHeader(rawArea);
        if (result) result.textContent = `Detected ${simple} — ${postcode}`;
        updateHeaderLabel(postcode, simple);

        localStorage.setItem('selected_pincode', JSON.stringify({ pin: postcode, area: simple }));

        // CLOSE + RELOAD
        setTimeout(function () {
          closeModal();
          location.reload();
        }, 300);

      } catch (err) {
        console.error(err);
        if (result) result.textContent = 'Error reverse-geocoding location.';
      }

    }, function () {
      if (result) result.textContent = 'Permission denied or timeout.';
      // On deny: header remains "Enter Pincode"
    }, { timeout: 30000 });

  });

  /* APPLY button */
  applyBtn && applyBtn.addEventListener('click', async function () {

    const pin = (input.value || '').trim();

    if (!/^\d{6}$/.test(pin)) {
      if (result) result.textContent = 'Please enter a valid 6-digit pincode.';
      return;
    }

    if (result) result.textContent = 'Checking...';

    const shipUrl = `https://shipclues.com/api/check-pincode-servicable?fm_pincode=${ORIGIN_PIN}&lm_pincode=${pin}`;

    let displayedArea = '';
  let isServiceable = false;

    try {
      const r = await fetch(shipUrl);
      if (r.ok) {
        const data = await r.json();
      console.log('Shipclues response:', data);

      // Shipclues returns {status: true/false, message: "..."} for you
      // Some setups also use "servicable" flag – support both.
      const statusFlag      = typeof data.status !== 'undefined' ? data.status : null;
      const servicableFlag  = typeof data.servicable !== 'undefined' ? data.servicable : null;

      isServiceable = (statusFlag === true) || (servicableFlag === true);

      if (!isServiceable) {
        // NOT SERVICEABLE / PINCODE NOT FOUND
        if (result) result.textContent = data.message || 'Not serviceable.';
        // Reset header + remove saved pincode
        updateHeaderLabel('', '');
        try { localStorage.removeItem('selected_pincode'); } catch(_) {}
        return; // IMPORTANT: stop here, do NOT geocode, do NOT reload
      }

      // Serviceable case – you might get area fields in future
      displayedArea = data.area || data.locality || data.city || data.city_name || '';
      if (result) result.textContent = 'Serviceable.';

      } else {
      // API not reachable / HTTP error – behave like old "Saved locally" logic
      if (result) result.textContent = 'Could not verify with courier, saving locally.';
      isServiceable = true; // allow user to continue as fallback
      }
    } catch (e) {
    console.error(e);
    if (result) result.textContent = 'Network error, saving locally.';
    isServiceable = true; // fallback
    }

  // If we reach here, either Shipclues said serviceable,
  // or we are in the "save locally" fallback.

  try {
    if (!displayedArea) {
      // Get a nice city/area name for header from Nominatim
      const g = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&q=${pin}&countrycodes=in&limit=1`
      );
        const arr = await g.json();
        if (arr[0] && arr[0].address) {
          displayedArea = extractAreaFromAddress(arr[0].address);
        }
    }
  } catch (_) {}

    const simple = simplifyAreaForHeader(displayedArea);
    updateHeaderLabel(pin, simple);

  try {
    localStorage.setItem('selected_pincode', JSON.stringify({ pin, area: simple }));
  } catch (_) {}

  // CLOSE + RELOAD only when we actually saved something
    setTimeout(function () {
      closeModal();
      location.reload();
    }, 300);

  });


  /* Restore saved pincode (from previous visits) */
  (function restoreSaved() {
    try {
      const saved = localStorage.getItem('selected_pincode');
      if (!saved) return;
      const obj = JSON.parse(saved);
      if (obj.pin) {
        const simple = simplifyAreaForHeader(obj.area);
        updateHeaderLabel(obj.pin, simple);
      }
    } catch (_) {}
  })();

  /* NEW: Auto ask for location on page load if nothing saved */
  (function autoAskLocationOnLoad() {
    // If we already have a saved pin, don't auto-ask
    try {
      const saved = localStorage.getItem('selected_pincode');
      if (saved) return;
    } catch (_) {}

    // If header already shows some city (from customer address), don't auto-ask
    if (
      headerCity &&
      headerCity.textContent &&
      headerCity.textContent.trim() !== 'Enter Pincode'
    ) {
      return;
    }

    if (!navigator.geolocation || !useLocationBtn) {
      return;
    }

    // Try using Permissions API to avoid useless prompt when already denied
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'geolocation' }).then(function (status) {
        if (status.state === 'denied') {
          // user has already blocked; keep "Enter Pincode"
          return;
        }
        // 'granted' or 'prompt' => trigger same behaviour as clicking "Use my location"
        useLocationBtn.click();
      }).catch(function () {
        // If permissions query fails, just try
        useLocationBtn.click();
      });
    } else {
      // No Permissions API – just attempt geolocation
      useLocationBtn.click();
    }
  })();

});
// new dvi for location finder
document.addEventListener('DOMContentLoaded', function () {

  const mobileBlocks = document.querySelectorAll('.header-pincode--mobile');
  if (!mobileBlocks.length) return;

  let pin = '';
  let city = '';

  try {
    const saved = localStorage.getItem('selected_pincode');
    if (saved) {
      const obj = JSON.parse(saved);
      pin  = obj.pin  || '';
      city = obj.area || '';
    }
  } catch (_) {}

  mobileBlocks.forEach(block => {
    const delivEl = block.querySelector('.header-pincode__deliv');
    if (!delivEl) return;

    if (city && pin) {
      // City + Pin
      delivEl.textContent = `Delivering to ${city} ${pin}`;
    } else if (city) {
      // Only city
      delivEl.textContent = `Delivering to ${city}`;
    } else if (pin) {
      // Only pin (IMPORTANT FIX)
      delivEl.textContent = `Delivering to ${pin}`;
    } else {
      delivEl.textContent = '';
    }

  });

});


// {% comment %} supper insta video js ... {% endcomment %}
 
(function(){
  "use strict";

  // normalize numeric text: remove currency symbols, non-digit unicode, NBSP, trim, convert localized digits, remove thousands separators
  function normalizeNumberString(str){
    if(!str) return null;
    // convert any non-breaking spaces to normal
    str = str.replace(/\u00A0/g, ' ');
    // replace localization digits (arabic-indic etc) with ascii digits if present
    // map of common unicode digits groups -> convert via char code offset
    const digitMaps = [
      {from: 0x0660, to: 0x0669}, // Arabic-Indic
      {from: 0x06F0, to: 0x06F9}, // Extended Arabic-Indic
      {from: 0x0966, to: 0x096F}, // Devanagari
      {from: 0x09E6, to: 0x09EF}, // Bengali
      // add more if needed
    ];
    let out = '';
    for(let ch of str){
      let code = ch.charCodeAt(0);
      let replaced = false;
      for(const m of digitMaps){
        if(code >= m.from && code <= m.to){
          out += String(code - m.from);
          replaced = true;
          break;
        }
      }
      if(!replaced) out += ch;
    }
    // remove anything that's not digit, dot, or comma or minus
    out = out.replace(/[^\d.,-]/g,'').trim();
    if(!out) return null;
    // If there are multiple dots/commas, heuristics:
    // If both comma and dot present assume dot is decimal if dot after comma or vice versa.
    // Simpler: remove thousands separators: treat comma as thousands sep if there's a dot later with two decimals or comma groups.
    // Remove commas entirely then parse.
    out = out.replace(/,/g, '');
    // If multiple dots exist (bad), keep last as decimal separator
    const dotCount = (out.match(/\./g)||[]).length;
    if(dotCount>1){
      // keep last dot, remove earlier dots
      const lastDot = out.lastIndexOf('.');
      out = out.slice(0,lastDot).replace(/\./g,'') + out.slice(lastDot);
    }
    return out;
  }

  function parsePrice(str){
    const norm = normalizeNumberString(str);
    if(!norm) return null;
    const n = parseFloat(norm);
    return isNaN(n) ? null : Math.round(n * 100) / 100; // round to 2 decimals
  }

  function processPriceBox(priceBox){
    if(!priceBox) return;
    const sEl = priceBox.querySelector('s');
    if(!sEl) return;

    // Extract compare price from <s>
    const comparePrice = parsePrice(sEl.textContent || sEl.innerText);
    // Extract actual price: take full text and remove <s> text to avoid duplicates
    const wholeHtml = priceBox.innerHTML || '';
    // create a temporary element to get text excluding <s>
    const clone = priceBox.cloneNode(true);
    const sInClone = clone.querySelector('s');
    if(sInClone) sInClone.remove();
    const actualText = clone.textContent || clone.innerText || '';
    const actualPrice = parsePrice(actualText);

    // Fallback: if actualPrice is null try to parse last numeric in whole text
    let fallbackActual = actualPrice;
    if(fallbackActual === null){
      const numbers = (wholeHtml.match(/[\d\.,]+/g) || []);
      if(numbers.length){
        fallbackActual = parsePrice(numbers[numbers.length-1]);
      }
    }

    // Final compare: both numeric and equal OR numeric difference tiny (<= 0.01)
    const cp = comparePrice;
    const ap = (fallbackActual !== null ? fallbackActual : actualPrice);

    let equal = false;
    if(cp !== null && ap !== null){
      equal = Math.abs(cp - ap) <= 0.01;
    } else if (cp !== null && ap === null){
      // fallback to string compare normalized
      const sNorm = normalizeNumberString(sEl.textContent || '');
      const wholeNorm = normalizeNumberString(priceBox.textContent || '');
      if(sNorm && wholeNorm && wholeNorm.indexOf(sNorm) !== -1){
        // try to remove first occurrence of sNorm and see if remainder contains same numeric
        const remainder = wholeNorm.replace(sNorm, '').trim();
        const remNum = parsePrice(remainder);
        if(remNum !== null){
          equal = Math.abs(cp - remNum) <= 0.01;
        }
      }
    }

    if(equal){
      sEl.style.display = 'none';
      priceBox.classList.add('sv-compare-hidden');
    } else {
      sEl.style.display = '';
      priceBox.classList.remove('sv-compare-hidden');
    }
  }

  function processAll(){
    document.querySelectorAll('.sup-video_product-text-price').forEach(processPriceBox);
  }

  // initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }

  // observe dynamic changes
  const observer = new MutationObserver(function(mutations){
    let run = false;
    for(const m of mutations){
      if(m.addedNodes && m.addedNodes.length){
        for(const n of m.addedNodes){
          if(n.nodeType === 1 && (n.classList && n.classList.contains && (n.classList.contains('sup-video_product') || n.querySelector && n.querySelector('.sup-video_product-text-price')))){
            run = true; break;
          }
        }
      }
      if(run) break;
    }
    if(run){
      clearTimeout(window.__sv_price_timeout);
      window.__sv_price_timeout = setTimeout(processAll, 60);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // also re-run on load
  window.addEventListener('load', function(){ setTimeout(processAll, 120); });

  // debug helper (comment out in production)
  // window.__sv_debug = {parsePrice: parsePrice, normalizeNumberString: normalizeNumberString};

})();
